<template>
    <div class="product-training">
        <div class="expert-div-lead head-protection-div-lead">
            <div class="expert-responsive-lead">
                <h3><span>EXPERT IN</span><strong>Head Protection</strong></h3>
                <img src="/images/st-learning/head-protection/exp-main-head.png" alt="hand protection">
                <h4>PIP provides a comprehensive offering of head protection, including hard hats, helmets and bump caps.</h4>
            </div>
            <div class="expert-div-info" ref="mobileView">
                <h2>Head Protection</h2>
                <p>
                    PIP provides a comprehensive offering of head protection, including hard hats, helmets and bump caps.  Our Hard Hats are available in numerous styles and colors, but that's only the beginning. Remarkable, proprietary features that out-perform the competition in comfort, suspension and retention meet and exceed the ANSI requirements. We also offer a line of Bump Caps to protect against incidental bumps and scrapes, as well as specialty helmets for industries such as high altitude workers, fire, rescue and wildland.
                </p>
            </div>
            <a href="javascript:void(0);" class="expert-read-info">
                <span @mousedown="showMobile" ref="readMore"><small>READ MORE</small><font-awesome-icon :icon="['fas', 'chevron-down']" /></span>
                <span @mousedown="hideMobile" ref="readLess"><small>CLOSE</small><font-awesome-icon :icon="['fas', 'chevron-up']" /></span>
            </a>
        </div>

        <div class="expert-div head-protection-expert-div" style="padding-top:50px;">
            <h2 class="none" id="expert-h2-heading">
                HARD HATS
            </h2>
            <p class="main">
                There are a number of factors that lead to choosing the proper hard hat for a working environment, including style, suspension, the ANSI/ISEA Z89.1-2014 standard risk assessment and electrical class.
            </p>
            <div class="expert-sub-menu">
                <span class="icon icon-hamburger" id="borger-1" @mousedown="burgerClicked('borger-1')"><font-awesome-icon :icon="['fas', 'bars']" /></span>
            </div>

            <div id="tech-th" class="expert-sub-menu-dropdown" ref="top-dropdown">
                <div id="tech-th-cap" style="border-bottom:solid 3px #cd1b00;" ref="tech-th-cap" @mouseover="techHover">
                    <img id="tech-th-cap-img" src="/images/st-learning/head-protection/tech-th-cap.jpg" width="150" height="86" alt="cap style hard hat" />
                    <br>CAP STYLE
                </div>
                <div id="tech-th-full" ref="tech-th-full" @mouseover="techHover">
                    <img id="tech-th-full-img" src="/images/st-learning/head-protection/tech-th-full.jpg" width="150" height="86" alt="full brim style hard hat" />
                    <br />FULL BRIM
                </div>
            </div>


            <div class="tech-center">
                <img src="/images/st-learning/head-protection/img-exp-cap-style---en.jpg"  ref="tech-img-cap"
                    alt="cap style hard hat" id="tech-img-cap" />
                <img src="/images/st-learning/head-protection/img-exp-full-brim.jpg" alt="full brim style hard hat" ref="tech-img-full"
                    id="tech-img-full" style="display:none;" />
            </div>


            <div id="tech-txt">
                <div id="tech-txt-cap" ref="tech-txt-cap">
                    <p>
                        <strong>CAP STYLE HARD HAT - Traditional styling with enhanced protection</strong><br />
                        Front brim is available in multiple lengths to best fit the application, standard 1" or short 1/2" &bull; Extended back area give more coverage at the back of the head and neck for extra deflection protection
                    </p>
                </div>

                <div id="tech-txt-full" style="display:none;" ref="tech-txt-full">
                    <p>
                        <strong>FULL BRIM HARD HAT - For additional protection against sun, glare, rain and falling debris</strong><br />
                         Shorter front brim shades the face while allowing excellent visibility, while the longer back brim helps protect neck and ears from the sun's UV rays and functions as a run-off for rain and snow &bull; Textured underside helps reduce reflection and glare
                    </p>
                </div>

            </div>

        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider" />

        <div class="expert-div">

            <h2 class="none" style="line-height:1.1;">Impact - ANSI Type I vs Type II</h2>
            <p class="main">
                Hard Hats in the US must meet the Z89.1-2014 safety standard set by ANSI/ISEA. The standard establishes the types and classes of hard hat options that provide appropriate protection for hazards in their specific workplaces.
            </p>

            <div id="expert-impact" class="clearfix">
                <div>
                    <img src="/images/st-learning/head-protection/img-ansi-impact-test.jpg" alt="ANSI impact test for hard hats" id="type1" ref="type1" style="display:block;" />
                    <img src="/images/st-learning/head-protection/280-AHS150---Impact-Penetration-Test.jpg" id="type2" ref="type2" width="600" style="display:none;" />
                </div>
                <div style="cursor:pointer;">
                    <div >
                        <img ref="type1-img" id="type1-img" @mouseover="techHover" src="/images/st-learning/head-protection/280-EV6161-10---FR.jpg" width="200" height="200" alt="top impact test on full brim hard hat" />
                        <p id="type1-text" ref="type1-text" @mouseover="techHover">
                            <strong ref="type1strong" style="color:#cd1b00;">Type I (Top Impact)</strong><br />designed to reduce the force of impact to the top of the head
                        </p>
                        <br />
                    </div>
                    <div >
                        <img id="type2-img" ref="type2-img" @mouseover="techHover" src="/images/st-learning/head-protection/280-AHS150---CROSS-SECTION.jpg" width="200" height="200" alt="cross section of a hard hat" />
                        <p id="type2-text" ref="type2-text" @mouseover="techHover">
                            <strong ref="type2strong">Type II (Top and Lateral Impact)</strong><br />
                            Offers Side (Lateral) Impact Protection which reduces the force of impact resulting from a blow which may be received off center as well as to the top of the head
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider" />

        <div class="expert-div">

            <h2 class="none" style="line-height:1.1;">Electrical Classes</h2>
            <div id="classes-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/head-protection/img-exp-class-e.jpg" width="276" height="177" alt="class E (electrical) hard hat" />
                        <p>
                            <strong>Class E (Electrical)</strong><br />protection means the hard hat is proof-tested at 20,000 volts.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/head-protection/img-exp-class-g.jpg" width="276" height="177"
                            alt="class G (general) hard hat" />
                        <p>
                            <strong>Class G (General)</strong><br />
                            protection means the hard hat is proof-tested at 2,200 volts.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/head-protection/img-exp-class-c.jpg" width="276" height="177"
                            alt="class c (conductive) hard hat" />
                        <p>
                            <strong>Class C (Conductive)</strong><br />
                            protection means the hard hat is not intended for use near electrical hazards, but is vented for breathability.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>
            <br />
            <p class="space" style="font-size:14px;">
                If the wearer is not using electrically insulated gloves or any other electrical protective clothing, it is likely that the Class E is not a necessary requirement to meet. In such cases, the benefits of a Class C Vented hard hat, such as comfort and reduced fatigue from heat exposure, will help improve output from the worker. Our Class C hard hats still have <strong>no metal components</strong>.
            </p>
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider" />

        <div class="expert-div">

            <h2 class="space">Suspension</h2>

            <p class="main">
                The suspension system of a hard hat absorbs the force of an impact. The amount of suspension points spread out the force of an impact to protect the wearer, dispersing the initial shock. Below is an example of what would happen when a ten pound impact hits a 4-Point and a 6-Point suspension.
            </p>

            <img src="/images/st-learning/head-protection/img-exp-suspension.jpg" style="max-width:100%; margin:40px 0 0 0;" alt="hard hat 6-point suspension" />


        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider" />

        <div class="expert-div">
            <h2 class="space">Size Adjustment</h2>

            <p class="main">
                A suspension is adjustable to properly fit the hard hat to the wearer's head.<br />Options are available for ease of use and cost.
            </p>
            <div id="styles-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/head-protection/Ratchet.jpg" alt="wheel ratchet adjustment system" width="276" />
                        <p>
                        <strong>WHEEL RATCHET</strong><br />
                                Provides quicker and easier adjustment, and is less likely to snag in longer hair.
                            </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/head-protection/Pinlock.jpg" width="276" alt="slip ratchet adjustment system" />
                        <p>
                            <strong>PINLOCK SYSTEM</strong><br />
                            A more economical solution that is still simple to adjust.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider" />

        <div class="expert-div" style="border-bottom:none;">

            <h2 class="space" id="expert-h2-heading">Bump Caps</h2>


            <p class="main">
                Getting workers to wear head protection can be tough, especially in areas where hard hats are not required. It’s estimated that <strong>a third</strong> of all impact injuries to the head are suffered by workers who bumped into stationary objects while not wearing any head protection. The low profile style of a bump cap increases wearer acceptability and reduces injuries.
            </p>

            <br />

            <h2 class="space">Features</h2>

            <div class="expert-sub-menu">
                <span class="icon icon-hamburger" id="borger-2" @mousedown="burgerClicked('borger-2')"><font-awesome-icon :icon="['fas', 'bars']" /></span>
            </div>

            <div id="tech-th" class="expert-sub-menu-dropdown" ref="bottom-dropdown">
                <div id="tech-th-bc-main" style="border-bottom:solid 3px #cd1b00;" ref="tech-th-bc-main" @mouseover="techHover">
                    <img src="/images/st-learning/head-protection/tech-th-bc-main.jpg" width="150" height="86" alt="bump cap outer design icon" id="tech-th-bc-main-img"/>
                    <br />DESIGN
                </div>
                <div id="tech-th-bc-liner" ref="tech-th-bc-liner" @mouseover="techHover">
                    <img src="/images/st-learning/head-protection/tech-th-bc-liner.jpg" width="150" height="86" alt="bump cap liner icon" id="tech-th-bc-liner-img"/>
                    <br />LINER
                </div>
                <div id="tech-th-bc-reflective" ref="tech-th-bc-reflective" @mouseover="techHover">
                    <img src="/images/st-learning/head-protection/tech-th-bc-reflective.jpg" width="150" height="86" alt="bump cap reflective piping icon" id="tech-th-bc-reflective-img"/>
                    <br />REFLECTIVE
                </div>
                <div id="tech-th-bc-brims" ref="tech-th-bc-brims" @mouseover="techHover">
                    <img src="/images/st-learning/head-protection/tech-th-bc-brims.jpg" width="150" height="86" alt="variety of bump cap brim lengths icon" id="tech-th-bc-brims-img"/>
                    <br />BRIM LENGTHS
                </div>
            </div>

            <div class="tech-center">
                <img src="/images/st-learning/head-protection/img-exp-bc-main.jpg" alt="bump cap outer design" id="tech-img-bc-main" ref="tech-img-bc-main"/>
                <img src="/images/st-learning/head-protection/img-exp-bc-liner.jpg" alt="bump cap liner" id="tech-img-bc-liner" style="display:none;" ref="tech-img-bc-liner"/>
                <img src="/images/st-learning/head-protection/img-exp-bc-reflective.jpg" alt="bump cap reflective piping" id="tech-img-bc-reflective" style="display:none;" ref="tech-img-bc-reflective"/>
                <img src="/images/st-learning/head-protection/img-exp-bc-brims---en.jpg" alt="variety of bump cap brim lengths" id="tech-img-bc-brims" style="display:none;" ref="tech-img-bc-brims" />
            </div>


            <div id="tech-txt" style="text-align:center;">
                <div id="tech-txt-bc-main" ref="tech-txt-bc-main">
                    <p>
                        <strong>BASEBALL CAP STYLE</strong> - Low profile, ultra sleek design increases user acceptability with the comfort and look of a regular baseball cap. Holes in the liner match up with mesh panels on the cap for coolness and comfort.
                    </p>
                </div>

                <div id="tech-txt-bc-liner" style="display:none;" ref="tech-txt-bc-liner">
                    <p>
                        <strong>HDPE LINER</strong> - The HDPE removable liner for front-to-back and side-to-side protection from bumps and scrapes.
                    </p>
                </div>

                <div id="tech-txt-bc-brims" style="display:none;" ref="tech-txt-bc-brims">
                    <p>
                        <strong>MULTIPLE BRIM LENGTHS</strong> - Available in 2.75" Standard Brim, 2" Short Brim or 1" Micro Brim to best fit the work application
                    </p>
                </div>

                <div id="tech-txt-bc-reflective" style="display:none;" ref="tech-txt-bc-reflective">
                    <p>
                        <strong>REFLECTIVE PIPING</strong> - Adds extra visibility and therefore safety in all working environments
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlickCarousel from "vue-slick-carousel";
    import "vue-slick-carousel/dist/vue-slick-carousel.css";
    import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
    export default {
        data() {
            return {
            name: 'Vue.js',
            settings: {
                  "autoplay": false,
                  "focusOnSelect": true,
                  "infinite": false,
                  "pauseOnFocus": true,
                  "slidesToShow": 3,
                  "speed": 500,
                  "arrows":true,
                  responsive: [
                      {
                      breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                      },
                      {
                      breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                      }
                    ]
                }
            }
        },

        methods: {
            techHover(event) {
                if(event){
                    var hoveredID = event.target.id;
                    switch(hoveredID) {
                        case "tech-th-cap":
                        case "tech-th-cap-img":
                            this.$refs['tech-th-cap'].style="border-bottom:solid 3px #cd1b00;";
                            this.$refs['tech-th-full'].style="border-bottom: none";
                            this.$refs['tech-txt-cap'].style="display: block";
                            this.$refs['tech-txt-full'].style="display: none";
                            this.$refs['tech-img-cap'].style="display: block";
                            this.$refs['tech-img-full'].style="display: none";
                            break;
                        case "tech-th-full":
                        case "tech-th-full-img":
                            this.$refs['tech-th-cap'].style="border-bottom: none";
                            this.$refs['tech-th-full'].style="border-bottom: solid 3px #cd1b00;";
                            this.$refs['tech-txt-cap'].style="display: none";
                            this.$refs['tech-txt-full'].style="display: block";
                            this.$refs['tech-img-cap'].style="display: none";
                            this.$refs['tech-img-full'].style="display: block";
                            break;
                        case "type2-text":
                        case "type2-img":
                            this.$refs['type1'].style="display: none";
                            this.$refs['type2'].style="display: block";
                            this.$refs['type1strong'].style="color: #666";
                            this.$refs['type2strong'].style="color: #cd1b00";
                            break;
                        case "type1-text":
                        case "type1-img":
                            this.$refs['type1'].style="display: block";
                            this.$refs['type2'].style="display: none";
                            this.$refs['type1strong'].style="color: #cd1b00";
                            this.$refs['type2strong'].style="color: #666im";
                            break;
                        case "tech-th-bc-main":
                        case "tech-th-bc-main-img":
                            this.$refs['tech-th-bc-main'].style="border-bottom: solid 3px #cd1b00;";
                            this.$refs['tech-th-bc-liner'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-reflective'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-brims'].style="border-bottom: solid 3px #fff;";

                            this.$refs['tech-img-bc-main'].style="display: block";
                            this.$refs['tech-img-bc-liner'].style="display: none";
                            this.$refs['tech-img-bc-reflective'].style="display: none";
                            this.$refs['tech-img-bc-brims'].style="display: none";

                            this.$refs['tech-txt-bc-main'].style="display: block";
                            this.$refs['tech-txt-bc-liner'].style="display: none";
                            this.$refs['tech-txt-bc-reflective'].style="display: none";
                            this.$refs['tech-txt-bc-brims'].style="display: none";
                            break;
                        case "tech-th-bc-liner":
                        case "tech-th-bc-liner-img":
                            this.$refs['tech-th-bc-main'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-liner'].style="border-bottom: solid 3px #cd1b00;";
                            this.$refs['tech-th-bc-reflective'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-brims'].style="border-bottom: solid 3px #fff;";

                            this.$refs['tech-img-bc-main'].style="display: none";
                            this.$refs['tech-img-bc-liner'].style="display: block";
                            this.$refs['tech-img-bc-reflective'].style="display: none";
                            this.$refs['tech-img-bc-brims'].style="display: none";

                            this.$refs['tech-txt-bc-main'].style="display: none";
                            this.$refs['tech-txt-bc-liner'].style="display: block";
                            this.$refs['tech-txt-bc-reflective'].style="display: none";
                            this.$refs['tech-txt-bc-brims'].style="display: none";
                            break;
                        case "tech-th-bc-reflective":
                        case "tech-th-bc-reflective-img":
                            this.$refs['tech-th-bc-main'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-liner'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-reflective'].style="border-bottom: solid 3px #cd1b00;";
                            this.$refs['tech-th-bc-brims'].style="border-bottom: solid 3px #fff;";

                            this.$refs['tech-img-bc-main'].style="display: none";
                            this.$refs['tech-img-bc-liner'].style="display: none";
                            this.$refs['tech-img-bc-reflective'].style="display: block";
                            this.$refs['tech-img-bc-brims'].style="display: none";

                            this.$refs['tech-txt-bc-main'].style="display: none";
                            this.$refs['tech-txt-bc-liner'].style="display: none";
                            this.$refs['tech-txt-bc-reflective'].style="display: block";
                            this.$refs['tech-txt-bc-brims'].style="display: none";
                            break;
                        case "tech-th-bc-brims":
                        case "tech-th-bc-brims-img":
                            this.$refs['tech-th-bc-main'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-liner'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-reflective'].style="border-bottom: solid 3px #fff;";
                            this.$refs['tech-th-bc-brims'].style="border-bottom: solid 3px #cd1b00;";

                            this.$refs['tech-img-bc-main'].style="display: none";
                            this.$refs['tech-img-bc-liner'].style="display: none";
                            this.$refs['tech-img-bc-reflective'].style="display: none";
                            this.$refs['tech-img-bc-brims'].style="display: block";

                            this.$refs['tech-txt-bc-main'].style="display: none";
                            this.$refs['tech-txt-bc-liner'].style="display: none";
                            this.$refs['tech-txt-bc-reflective'].style="display: none";
                            this.$refs['tech-txt-bc-brims'].style="display: block";
                            break;
                    }
                    
                }
            },
            showMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: block;";
                    this.$refs['readMore'].style="display: none;";
                    this.$refs['readLess'].style="display: block;";
                }
            },
            hideMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: none;";
                    this.$refs['readMore'].style="display: block;";
                    this.$refs['readLess'].style="display: none;";
                }
            },
            burgerClicked(id) {

                    if(id == "borger-1") {
                        if (this.$refs['top-dropdown'].style.display != "block") {
                        this.$refs['top-dropdown'].style="display: block;";
                        } else {
                            this.$refs['top-dropdown'].style="display: none;";
                        }
                    } else if(id == "borger-2") {
                        if (this.$refs['bottom-dropdown'].style.display != "block") {
                        this.$refs['bottom-dropdown'].style="display: block;";
                        } else {
                            this.$refs['bottom-dropdown'].style="display: none;";
                        }
                    }
            }
        },
        components: { VueSlickCarousel }
    }
                
</script>
